import * as React from "react";
import Component from "../../AbstractComponent";
import { connect } from "react-redux";
import Constants from "../../../Action/Constants";
import Time from "../../../Time/Time";
import { TableComponent } from "../../Partials/Table/TableComponent";
import { EventInterface } from "../../../Entity/Entities/Event/EventInterface";
import { PromptDialog } from "../../Partials/Dialog/PromptDialog";
import { TabsComponent } from "./TabsComponent";
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Card from '@material-ui/core/Card';
import IconButton from '@material-ui/core/IconButton';
import TableCell from '@material-ui/core/TableCell';
import TableRow from '@material-ui/core/TableRow';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import TextField from "../../Partials/Material/TextField";
import Checkbox from '@material-ui/core/Checkbox';
import Button from '@material-ui/core/Button';
import { Property } from "../../../Entity/Entities/Property/Property";
import { Unit } from "../../../Entity/Entities/Unit/Unit";
import { Charge } from "../../../Entity/Entities/Charge/Charge";
import { Event } from "../../../Entity/Entities/Event/Event";
import CircularProgress from '@material-ui/core/CircularProgress';
import CreateTaskDialog from "../../Partials/Dialog/CreateTaskDialog";
import { PageTransition } from "../../Partials/Spinner/PageTransition";
import { Switch } from "@material-ui/core";

class Tasks extends Component {
  protected paginatorPath: string = !!this.props.app.tasksFilterSearchState ?
    `Tasks_${this.props.app.tasksFilterSearchState}` :
    `Tasks`;

  protected userId: number = this.props.app.session.user.id;
  protected currentTask;
  protected searchTimer;

  public state = {
    isDeleteTaskPopupOpen: false,
    currentTask: null,
    tasks: [],
    unfinishedTasks: [],
    tasksCount: 0,
    unfinishedTasksCount: 0,
    isSaving: false,
    anchorEl: null,
    isFetching: true,
    filterValue: this.props.app.tasksFilterSearchState,
    assignedToMe: false,
    createdByMe: false,
    // includeActivitiesTasks: this.props.app.activityTemplates
    //                         .filter(activityTemplate => !activityTemplate.removed).length > 0 &&
    //                         this.props.app.settings.agency.isActivitiesShown ? true : false,
    includeActivitiesTasks: true,
    includeAll: false,
    includeSnoozed: false,
    displayFinished: false,
    searchInProgress: false,
    isNewTaskPopupOpen: false,
  };

  constructor(public props) {
    super(props);
  }

  public componentWillMount() {
    this.setState({
      ...this.state,
      ...this.props.app.tasksFilterCheckBoxState
    }, () => {
      this.setState({
        includeActivitiesTasks: this.props.app.activityTemplates
          .filter(activityTemplate => !activityTemplate.removed).length > 0 &&
          this.props.app.settings.agency.isActivitiesShown ? this.state.includeActivitiesTasks : false,
      }, this.fetchTasks)
    })
  }

  public componentWillUnmount() {
    clearTimeout(this.searchTimer);
  }

  public fetchFirstAllTasks = () => {
    // const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
    //   this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      // offset: 0,
      // limit: paginationAmount,
      filterValue: this.state.filterValue,
      eventTypeIds: [35, 38], // task || incident
      removed: 0,
    };

    if (this.state.assignedToMe) {
      payload.executorId = this.userId;
    }

    if (this.state.createdByMe) {
      payload.createdById = this.userId;
    }

    payload.includeActivitiesTasks = this.state.includeActivitiesTasks;

    // if (this.state.includeSnoozed) {
    payload.isSnoozed = Number(this.state.includeSnoozed);
    payload.reacted = Number(this.state.displayFinished);
    // }

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => this.setState({
        searchInProgress: false,
        tasks: data.events,
        tasksCount: data.count,
        isFetching: false
      }),
      onError: () => {
        this.setState({
          searchInProgress: false,
          isFetching: false
        });
      }
    });
  }

  public fetchFirstUnfinishedTasks = () => {
    // const paginationAmount = !!this.props.app.paginator && !!this.props.app.paginator[this.paginatorPath] ?
    //   this.props.app.paginator[this.paginatorPath]: this.props.app.defaultPaginationAmount;

    const payload: any = {
      // offset: 0,
      // limit: paginationAmount,
      filterValue: this.state.filterValue,
      eventTypeIds: [35, 38], // task || incident
      removed: 0,
      reacted: 0
    };

    if (this.state.assignedToMe) {
      payload.executorId = this.userId;
    }

    if (this.state.createdByMe) {
      payload.createdById = this.userId;
    }

    payload.includeActivitiesTasks = this.state.includeActivitiesTasks;

    // if (this.state.includeSnoozed) {
    payload.isSnoozed = Number(this.state.includeSnoozed);
    // }

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...payload
      },
      onSuccess: (data) => this.setState({
        searchInProgress: false,
        unfinishedTasks: data.events,
        unfinishedTasksCount: data.count,
        isFetching: false
      }),
      onError: () => {
        this.setState({
          searchInProgress: false,
          isFetching: false
        });
      }
    });
  }

  public fetchFilterAllTasks = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        filterValue: this.state.filterValue,
        eventTypeIds: [35, 38], // task || incident
        removed: 0
      },
      onSuccess: data => {
        this.setState({
          tasks: data.events,
          unfinishedTasksCount: data.count,
          isFetching: false
        })
      }
    })
  }

  public fetchFilterUnfinishedTasks = () => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        filterValue: this.state.filterValue,
        eventTypeIds: [35, 38], // task || incident
        removed: 0,
        reacted: 0
      },
      onSuccess: data => {
        this.setState({
          unfinishedTasks: data.events,
          unfinishedTasksCount: data.count,
          isFetching: false
        })
      }
    })
  }

  public clearFilterAllTasks = () => {
    this.props.dispatch({
      type: Constants.TASK_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstAllTasks);
  }

  public clearFilterUnfinishedTasks = () => {
    this.props.dispatch({
      type: Constants.TASK_FILTER_SEARCH_UPDATE_STATE,
      payload: {
        filter: ""
      }
    });

    this.setState({
      filterValue: ""
    }, this.fetchFirstUnfinishedTasks);
  }

  public setFilterValue = (event): any => {
    clearTimeout(this.searchTimer);

    this.setState({
      filterValue: event.target.value
    }, () => {
      if (this.state.filterValue === "") {
        if (this.state.includeAll) {
          this.clearFilterAllTasks();
        } else {
          this.clearFilterUnfinishedTasks();
        }
      }

      this.searchTimer = setTimeout(() => {
        this.setState({
          searchInProgress: true
        }, () => {
          this.paginatorPath = !!this.state.filterValue ?
            `Tasks_${this.state.filterValue}` :
            `Tasks`;

          this.props.dispatch({
            type: Constants.TASK_FILTER_SEARCH_UPDATE_STATE,
            payload: {
              filter: this.state.filterValue
            }
          });

          if (this.state.includeAll) {
            this.fetchFirstAllTasks();
          } else {
            this.fetchFirstUnfinishedTasks();
          }
        });
      }, this.props.app?.listSearchTimeout);
    });
  }

  public fetchTasks = () => {
    if (this.state.includeAll) {
      const payload: any = {
        // offset: !!this.state.tasks ?  this.state.tasks.length : 0,
        // limit: this.props.app.defaultPaginationAmount,
        filterValue: this.state.filterValue,
        eventTypeIds: [35, 38], // task || incident
        removed: 0
      };

      if (this.state.assignedToMe) {
        payload.executorId = this.userId;
      }

      if (this.state.createdByMe) {
        payload.createdById = this.userId;
      }

      payload.includeActivitiesTasks = this.state.includeActivitiesTasks;

      // if (this.state.includeSnoozed) {
      payload.isSnoozed = Number(this.state.includeSnoozed);
      payload.reacted = Number(this.state.displayFinished);
      // }

      this.props.dispatch({
        type: Constants.GLOBAL_EVENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          // const tasksArr: EventInterface[] = !!this.state.tasks ?
          //                                         [...this.state.tasks, ...data.events] : [...data.events];

          const tasksArr: EventInterface[] = [...data.events];

          this.setState({
            tasks: tasksArr,
            tasksCount: data.count,
            isFetching: false
          });
        }
      });
    } else {
      const payload: any = {
        // offset: !!this.state.unfinishedTasks ?  this.state.unfinishedTasks.length : 0,
        // limit: this.props.app.defaultPaginationAmount,
        filterValue: this.state.filterValue,
        eventTypeIds: [35, 38], // task || incident
        removed: 0,
        reacted: 0
      };

      if (this.state.assignedToMe) {
        payload.executorId = this.userId;
      }

      if (this.state.createdByMe) {
        payload.createdById = this.userId;
      }

      payload.includeActivitiesTasks = this.state.includeActivitiesTasks;

      // if (this.state.includeSnoozed) {
      payload.isSnoozed = Number(this.state.includeSnoozed);
      payload.reacted = Number(this.state.displayFinished);
      // }

      this.props.dispatch({
        type: Constants.GLOBAL_EVENTS_SAVE_LIST,
        payload: {
          ...payload
        },
        onSuccess: (data) => {
          // const unfinishedTasksArr: EventInterface[] = !!this.state.unfinishedTasks ?
          //                                 [...this.state.unfinishedTasks, ...data.events] : [...data.events];

          const unfinishedTasksArr: EventInterface[] = [...data.events];

          this.setState({
            unfinishedTasks: unfinishedTasksArr,
            unfinishedTasksCount: data.count,
            isFetching: false
          });
        }
      });
    }
  }

  public changeIncludeAllFilter = (): void => {
    this.setState({
      includeAll: !this.state.includeAll
    }, () => {
      if (this.state.includeAll) {
        if (this.state.filterValue) {
          this.fetchFilterAllTasks();
        } else {
          this.fetchFirstAllTasks();
        }
      } else {
        if (this.state.filterValue) {
          this.fetchFilterUnfinishedTasks();
        } else {
          this.fetchFirstUnfinishedTasks();
        }
      }
    });

    this.props.dispatch({
      type: Constants.PAGE_TASKS_LIST_CHECK_FILTER,
      payload: {
        includeAll: !this.state.includeAll,
      }
    });
  }

  public getAmountsOfFilteredTasks = (includeAll: boolean): number => {
    if (includeAll) {
      return this.state.tasksCount;
    } else {
      return this.state.unfinishedTasksCount;
    }
  }

  public getFilteredTasks = (includeAll: boolean): EventInterface[] => {
    if (includeAll) {
      return this.state.tasks;
    } else {
      return this.state.unfinishedTasks;
    }
  }

  public deleteTask = (task: EventInterface) => {
    this.props.dispatch({
      type: Constants.GLOBAL_EVENT_DELETE_START,
      payload: {
        event: task
      },
      onSuccess: () => {
        this.updateTasksCount();
        if (this.state.displayFinished) {
          this.fetchTasks()
        } else {
          this.fetchFirstAllTasks();
          this.fetchFirstUnfinishedTasks();
        }

      }
    });
  }

  protected openMenu = (event: any, task: EventInterface): void => {
    this.currentTask = task;

    this.setState({
      currentTask: task,
      anchorEl: event.currentTarget
    });
  }

  protected closeMenu = (): void => {
    this.setState({
      anchorEl: null
    });
  }

  public updateTasksCount = () => {
    const payloadTasks: any = {
      offset: 0,
      eventTypeIds: [35, 38], // task || incident
      removed: 0,
      // executorId: this.props.app?.session?.user?.id,
      includeActivitiesTasks: false,
      isSnoozed: 0,
      reacted: 0
    };

    this.props.dispatch({
      type: Constants.GLOBAL_EVENTS_SAVE_LIST,
      payload: {
        ...payloadTasks
      },
      onSuccess: (data) => {
        this.props.dispatch({
          type: Constants.GLOBAL_SAVE_NOTFINISHED_TASKS_COUNT,
          payload: {
            dashboardTasksCount: data.count
          }
        })
      }
    });
  }

  public changeTaskStatus = () => {
    let selectedEntityForTask;

    if (!this.state.currentTask) {
      return;
    }

    const task: any = {
      id: !!this.state.currentTask && this.state.currentTask.id,
      content: {
        name: this.state.currentTask.content && this.state.currentTask.content.name,
        details: this.state.currentTask.content && this.state.currentTask.content.details,
      },
      executorId: this.state.currentTask.executorId,
      executionDate: this.state.currentTask.executionDate ? Time.formatOrNull(this.state.currentTask.executionDate) : null,
      snoozeDate: this.state.currentTask.snoozeDate ? Time.formatOrNull(this.state.currentTask.snoozeDate) : null,
      reporterId: this.state.currentTask.reporterId,
      eventTypeId: 35, // task
      reacted: !this.state.currentTask.reacted
    };

    if (selectedEntityForTask instanceof Property) {
      task.propertyId = selectedEntityForTask.id;
    }

    if (selectedEntityForTask instanceof Unit) {
      task.unitId = selectedEntityForTask.id;
    }

    if (selectedEntityForTask instanceof Charge) {
      task.chargeId = selectedEntityForTask.id;
    }

    if (selectedEntityForTask instanceof Event) {
      task.eventId = selectedEntityForTask.id;
    }

    this.saving(() => {
      this.props.dispatch({
        type: Constants.GLOBAL_EVENT_UPDATE_START,
        payload: {
          ...task
        },
        onSuccess: () => {
          this.updateTasksCount();

          this.setState({
            anchorEl: null,
            isSaving: false,
          }, () => {
            this.fetchFirstUnfinishedTasks();
            this.fetchFirstAllTasks();
          })
        },
        onError: () => {
          this.setState({
            isSaving: false
          });
        }
      });
    });
  }

  public getTasks = () => {
    return this.getFilteredTasks(this.state.includeAll)
      .map((task: EventInterface, index: number) => {
        return (
          <TableRow
            hover
            key={index}
            className={`clickable-entity`}
            onClick={() => this.redirect(`/app/task/update/${task.id}`)}
          >
            <TableCell style={{ width: "24px", paddingLeft: "24px", paddingRight: "0px" }}>
              <div style={{ display: "flex", alignItems: "center", justifyContent: "center", paddingTop: "4px" }}>
                <div
                  className={`icon icon-ic-task ${task.reacted ? "" : task.getIconColor}`}
                >
                </div>
              </div>
            </TableCell>
            <TableCell style={{ width: "15%" }}>{!!task.createdAt && this.formatter.formatDate(new Date(task.createdAt))}</TableCell>
            <TableCell style={{ width: "20%" }}>{!!task.content && task.content.name}</TableCell>
            <TableCell style={{ width: "30%" }}>{!!task.object && task.object.shortDisplayName}</TableCell>
            <TableCell>{task && task.executorCompany ? task.executorCompany.name : task && task.executor ?`${task.executor.firstName} ${task.executor.lastName}` : ""}</TableCell>
            <TableCell style={{ width: "5%" }}>{
              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "flex-start",
                }}
              >
                <div className={`list-label creation-type-label`}>
                  {!!task.reacted ? this.trans("status-closed") : this.trans("status-open")}
                </div>
              </div>
            }
            </TableCell>
            <TableCell>
              {task.refersToEventId && (
                <div
                  style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center"
                  }}
                >
                  <div className="list-label creation-type-label">{this.trans("activity")}</div>
                </div>
              )}
            </TableCell>
            <TableCell
              onClick={e => {
                e.stopPropagation();
              }}
            >
              <div>
                <IconButton
                  onClick={e => this.openMenu(e, task)}
                >
                  <div className="icon icon-ic-more-vert"></div>
                </IconButton>
                <Menu
                  id="simple-menu"
                  anchorEl={this.state.anchorEl}
                  open={Boolean(this.state.anchorEl) && this.state.currentTask && this.state.currentTask.id === task.id}
                  onClose={this.closeMenu}
                  disableAutoFocusItem={true}
                  anchorOrigin={{
                    vertical: "bottom",
                    horizontal: "center"
                  }}
                  transformOrigin={{
                    vertical: "top",
                    horizontal: "left"
                  }}
                  getContentAnchorEl={null}
                >
                  <MenuItem
                    onClick={() => this.redirect(`/app/task/update/${this.currentTask && this.currentTask.id}`)}
                  >
                    <ListItemIcon><div className="icon icon-ic-edit aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-open")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={this.changeTaskStatus}
                  >
                    <ListItemIcon><div className={`icon icon-ic-${this.state.currentTask && this.state.currentTask.reacted ? "reopen" : "close"} aligned`}></div></ListItemIcon>
                    <ListItemText>{this.state.currentTask && this.state.currentTask.reacted ? this.trans("menu/status-option/open") : this.trans("menu/status-option/close")}</ListItemText>
                  </MenuItem>
                  <MenuItem
                    onClick={() => this.setState({ isDeleteTaskPopupOpen: true, anchorEl: null })}
                  >
                    <ListItemIcon><div className="icon icon-ic-remove aligned"></div></ListItemIcon>
                    <ListItemText>{this.trans("menuitem-delete")}</ListItemText>
                  </MenuItem>
                </Menu>
              </div>
            </TableCell>
          </TableRow>
        );
      });
  }

  public changeAssignedToMeFilter = () => {
    this.setState({
      assignedToMe: !this.state.assignedToMe
    }, this.fetchTasks);

    this.props.dispatch({
      type: Constants.PAGE_TASKS_LIST_CHECK_FILTER,
      payload: {
        assignedToMe: !this.state.assignedToMe,
      }
    });
  }

  public changeCreatedByMeFilter = () => {
    this.setState({
      createdByMe: !this.state.createdByMe
    }, this.fetchTasks);

    this.props.dispatch({
      type: Constants.PAGE_TASKS_LIST_CHECK_FILTER,
      payload: {
        createdByMe: !this.state.createdByMe
      }
    });
  }

  public changeIncludeSnoozedFilter = () => {
    this.setState({
      includeSnoozed: !this.state.includeSnoozed
    }, this.fetchTasks);

    this.props.dispatch({
      type: Constants.PAGE_TASKS_LIST_CHECK_FILTER,
      payload: {
        includeSnoozed: !this.state.includeSnoozed
      }
    });
  }
  public changeDisplayFinishedFilter = () => {
    this.setState({
      displayFinished: !this.state.displayFinished
    }, this.fetchTasks);

    this.props.dispatch({
      type: Constants.PAGE_TASKS_LIST_CHECK_FILTER,
      payload: {
        displayFinished: !this.state.displayFinished
      }
    });
  }

  public changeIncludeActivitiesTasksFilter = () => {
    this.setState({
      includeActivitiesTasks: !this.state.includeActivitiesTasks
    }, this.fetchTasks);

    this.props.dispatch({
      type: Constants.PAGE_TASKS_LIST_CHECK_FILTER,
      payload: {
        includeActivitiesTasks: !this.state.includeActivitiesTasks
      }
    });
  }

  public render() {
    return (
      <div className="state-app">
        <div className={`box box-full component-dashboard has-general-page-header with-tabs ${this.props.app?.settings?.user?.launchPanelState ? "with-launchpanel" : ""}`}>
          <div className="component-header no-paddings">
            <h1>{this.trans("title-dashboard")}</h1>
            <TabsComponent
              activeTab={6}
              {...this.props}
            />
          </div>

          <div className="component-wrapper no-margin-top">
            <Card className="card no-padding">
              <div className="label-container"
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  height: "48px",
                  maxHeight: "48px"
                }}
              >
                <h3 className="card-title">
                  {this.trans("tasks")}
                </h3>

                <Button
                  variant="contained"
                  color="primary"
                  onClick={() => this.setState({ isNewTaskPopupOpen: true })}
                >
                  {this.trans("new-task")}
                </Button>
              </div>

              <div>
                <div>
                  <div
                    className="list-filters-wrapper"
                  >
                    <div style={{ display: "flex" }}>
                      <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.assignedToMe}
                            onChange={this.changeAssignedToMeFilter}
                            color="primary"
                          />
                        }
                        label={this.trans("assigned-to-me")}
                      />

                      {/* <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.createdByMe}
                            onChange={this.changeCreatedByMeFilter}
                            color="primary"
                          />
                        }
                        label={this.trans("created-by-me")}
                      /> */}

                      {/* <FormControlLabel
                        control={
                          <Checkbox
                            checked={this.state.includeSnoozed}
                            onChange={this.changeIncludeSnoozedFilter}
                            color="primary"
                          />
                        }
                        label={this.trans("include-still-to-show")}
                      /> */}

                      {/* {
                        this.props.app.activityTemplates.filter(activityTemplate => !activityTemplate.removed).length > 0 && this.props.app.settings.agency.isActivitiesShown && (
                          <FormControlLabel
                            control={
                              <Checkbox
                                checked={this.state.includeActivitiesTasks}
                                onChange={this.changeIncludeActivitiesTasksFilter}
                                color="primary"
                              />
                            }
                            label={this.trans("include-activities-tasks")}
                          />
                        )
                      } */}

                    </div>

                    <div className="table-filterer" style={{ display: "flex" }}>

                      <FormControlLabel
                        control={
                          <Switch
                            value={this.state.displayFinished}
                            onChange={this.changeDisplayFinishedFilter}
                            color="primary"
                          />
                        }
                        label={this.trans("include-closed")}
                      />
                      <TextField
                        autoComplete="off"
                        type="text"
                        style={{ color: "rgb(0, 188, 212)" }}
                        label={this.trans("label-search")}
                        value={this.state.filterValue}
                        onChange={this.setFilterValue}
                        variant="standard"
                        error={false}
                      />
                      {this.state.filterValue !== "" &&
                        <div className="icon icon-ic-close clear-button clear-button-search" onClick={this.state.includeAll ? this.clearFilterAllTasks : this.clearFilterUnfinishedTasks}></div>
                      }
                      {
                        this.state.searchInProgress &&
                        <div className="search-loader">
                          <CircularProgress size={20} />
                        </div>
                      }
                    </div>
                  </div>
                </div>
                <TableComponent
                  {...this.props}
                  paginator={{
                    name: this.paginatorPath,
                    path: this.props.app.paginator
                  }}
                  className="listing-table tasks-listing-table with-first-border"
                  headers={[
                    "", this.trans("created"), this.trans("description"), this.trans("object"), this.trans("assignee"), this.trans("status"), "", ""
                  ]}
                  rows={this.getTasks()}
                  rowsLength={this.getAmountsOfFilteredTasks(this.state.includeAll)}
                  subtitle={this.trans("title-no-tasks-to-list")}
                  fetch={this.fetchTasks}
                  isFetching={this.state.isFetching}
                  filtering={this.state.filterValue.length > 0}
                />
              </div>
            </Card>
          </div>
        </div>

        <PromptDialog
          {...this.props}
          title={this.trans("delete-task")}
          content={this.trans("you-are-about-to-delete-task", { name: this.state.currentTask && this.state.currentTask.content && this.state.currentTask.content.name })}
          negativeButtonLabel={this.trans("button-cancel")}
          positiveButtonLabel={this.trans("button-remove")}
          openLeavePrompt={this.state.isDeleteTaskPopupOpen}
          prioritizeClosing={true}
          onDiscard={() => { this.setState({ isDeleteTaskPopupOpen: false }); }}
          onSave={() => { this.setState({ isDeleteTaskPopupOpen: false }); this.deleteTask(this.state.currentTask) }}
          positiveButtonStyle={{ backgroundColor: "red" }}
          hideCross={true}
        />

        <CreateTaskDialog
          {...this.props}
          isOpen={this.state.isNewTaskPopupOpen}
          closeDialog={() => {
            this.setState({
              isNewTaskPopupOpen: false,
              isSaving: false,
              anchorEl: null
            })
          }}
        />

        <PageTransition isSaving={this.state.isSaving} />
      </div>
    );
  }
}

const mapStateToProps = state => {
  return {
    app: state.app,
    events: state.events,
    units: state.units,
    component: state.tasks,
    globalTypes: state.globalTypes
  };
};

export default connect(mapStateToProps)(Tasks);
